<template>
    <div>
      <div id="container-table">
        <ts-loading-banner :loading="getting_invoice">
          <table class="table table-hover ui-table">
            <thead>
              <tr>
                <th>{{ $t('invoiceConfirm.invoice') }}</th>
                <th>{{ $t('invoiceConfirm.student') }}</th>
                <th>{{ $t('invoiceConfirm.academicInfo') }}</th>
              </tr>
              <tr>
                <th colspan="3">
                  <input
                    v-model="search"
                    type="text"
                    class="form-control"
                    :placeholder="$t('invoiceConfirm.placeholder')"
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(inv, index) in invoice_list"
                :key="index"
                @dblclick="selected(index, inv)"
                :class="{ 'selected-class': index == selectedIndex }"
              >
                <td>
                  <p
                    class="text-primary"
                    v-tooltip="$t('invoiceConfirm.invoiceNumber')"
                  >
                    <i class="fas fa-file-invoice mr-2"></i>
                    <strong>{{ inv.inv_number }}</strong>
                  </p>
                  <p v-tooltip="$t('invoiceConfirm.invoiceDate')">
                    <i class="fa fa-clock mr-2"></i>
                    {{ inv.inv_date }}
                  </p>
                </td>
                <td>
                  <p class="text-primary" v-tooltip="$t('invoiceConfirm.studentName')">
                    <i class="fa fa-user mr-2"></i>
                    <strong>{{ inv.first_name_en }} {{ inv.last_name_en }}</strong>
                  </p>
                  <p v-tooltip="$t('invoiceConfirm.studentId')">
                    <i class="far fa-id-card mr-2"></i>
                    {{ inv.card_number }}
                  </p>
                  <p
                    v-if="inv.phone"
                    v-tooltip="$t('invoiceConfirm.phoneNumber')"
                  >
                    <i class="fa fa-phone mr-2"></i>
                    {{ inv.phone }}
                  </p>
                  <p v-tooltip="$t('invoiceConfirm.sex')">
                    <i class="fa fa-venus-mars mr-2"></i>
                    {{ inv.gender }}
                  </p>
                </td>
                <td>
                  <p v-tooltip="$t('invoiceConfirm.subProgram')">
                    <i class="fa fa-book-open mr-2"></i>
                    {{ inv.acps_name_foreign }}
                  </p>
                  <p v-tooltip="$t('invoiceConfirm.academicYear')" class="text-primary">
                    <i class="fas fa-th mr-2"></i>
                    {{ inv.ac_year }}
                  </p>
                  <p v-tooltip="$t('invoiceConfirm.academicTerm')">
                    <i class="fas fa-cog mr-2"></i>
                    {{ inv.term_name }}
                    <span
                      class="badge badge-success"
                      v-if="inv.ac_status_id == 1"
                      >{{ $t('invoice.current') }}</span
                    >
                    <span
                      class="badge badge-danger"
                      v-if="inv.ac_status_id == 2"
                      >History</span
                    >
                    <span
                      class="badge badge-warning"
                      v-if="inv.ac_status_id == 3"
                      >{{ $t('invoice.next') }}</span
                    >
                  </p>
                  <p v-tooltip="$t('invoiceConfirm.className')" class="text-info">
                    <i class="fa fa-layer-group mr-2"></i>
                    {{ inv.class_name }}
                  </p>
                  <p v-tooltip="$t('invoiceConfirm.studyTime')" class="text-warning">
                    <i class="fa fa-clock mr-2"></i>
                    {{ inv.study_time }}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </ts-loading-banner>
      </div>
    </div>
  </template>
  
  <script>
  import { mapActions } from 'vuex'
  import { debounce } from 'lodash'
  
  export default {
    name: 'invoiceList',
    data() {
      return {
        getting_invoice: false,
        search: null,
        selectedIndex: null,
        invoice_list: []
      }
    },
    created() {
      this.fetchInvoice()
    },
    methods: {
      ...mapActions('invoiceConfirm', ['formViewModel']),
      fetchInvoice() {
        if (!this.search) return
        this.getting_invoice = true
        this.formViewModel({
          fnName: 'invoice',
          search: this.search
        })
          .then(response => {
            this.invoice_list = response.invoice
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.getting_invoice = false
          })
      },
      selected(index, row) {
        this.invoice_list = this.invoice_list.filter(el => el.inv_id == row.inv_id);
        this.selectedIndex = 0;
        this.$emit('selected', row)
      }
    },
    watch: {
      search: debounce(function(value) {
        if (value !== null || value !== '') {
          this.fetchInvoice()
        }
        this.invoice_list = []
      }, 600)
    }
  }
  </script>
  
  <style lang="css" scoped>
  #container-table {
    max-height: 35vh;
      height: 30vh;
    overflow: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;
    white-space: nowrap;
  }
  
  .table > thead > tr > th {
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    /* z-index: 999; */
    padding: 5px 15px;
  }
  .table > tbody > tr > td {
    padding-top: 5px !important;
    padding-bottom: 5px !important;
    border: none !important;
    cursor: pointer;
    font-size: 12px !important;
  }

  .selected-class {
    border-bottom: 1px solid #fafafa;
    border-top: 1px solid #fafafa;
    background: #e4eaf3;
    font-weight: 700;
  }
  </style>
  